module.exports = __webpack_public_path__ + "img/product_shiseido_1@2x.28ba8a0a.png";